import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInspect = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M6 6h28v14h-3.5V9.5h-21v21H20V34H6z" }), /* @__PURE__ */ _jsx("path", { d: "m22 22 20 7-8 3 7.5 7.5-3 3L31 35l-3 8z" })]
});
export default SvgInspect;
